import React from 'react';
import "react-widgets/styles.css";
import PropTypes from 'prop-types';
import ReactDropdownList from 'react-widgets/DropdownList';
import cx from 'classnames';

const DropdownList = (props) => {
	let rootClassName = cx('Dropdown', 'form-group', props.className);

	return (
		<div className={rootClassName}>
			<label className={cx({ 'd-none': props.label == undefined })} htmlFor={props.id}> {props.label} </label>
			<ReactDropdownList
				className={cx({ 'is-invalid': props.touched && props.error })}
				id={props.id}
				data={props.data}
				textField={props.textField}
				valueField={props.valueField}
				value={props.value}
				onChange={props.onChange}
				onBlur={() => props.onBlur(props.value)}
				placeholder={props.placeholder}
				filter='contains'
				renderListItem={ListItem}
			/>

			<div className='form-control is-invalid d-none'></div>
			{props.touched && props.error &&
				<div className='invalid-feedback'>{props.error}</div>
			}
		</div>
	);
};

// stateless functional component to define how list items are rendered in dropdown
const ListItem = (props) => {
	return (
		<div>
			<strong>{props.item.displayValue}</strong>
			<br />
			{props.item.secondaryDisplayValue}
		</div>
	);
};

DropdownList.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	className: PropTypes.string.isRequired,
	data: PropTypes.array.isRequired,
	textField: PropTypes.string.isRequired,
	valueField: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired,
	touched: PropTypes.bool.isRequired,
	error: PropTypes.string.isRequired,
	placeholder: PropTypes.string.isRequired
};

ListItem.propTypes = {
	item: PropTypes.shape({
		displayValue: PropTypes.string.isRequired,
		secondaryDisplayValue: PropTypes.string
	}).isRequired
};

export default DropdownList;
